<div class="videochat" *ngIf="videochatRunnable">
    <div class="videochat-stage">
        <div
            class="videochat-timer"
            *ngIf="showTimer"
            [ngClass]="{'timer_container': timerOffset < timeToWarning,'timer_container_warning': timerOffset >= timeToWarning}">
            <mat-icon class="videochat-timer__icon">schedule</mat-icon>
            <span class="videochat-timer__value">{{ timer }}</span>
        </div>
        <iframe
            class="videochat-frame"
            title="Videochiamata"
            [src]="roomUrl"
            allow="camera; microphone; fullscreen; speaker; display-capture">
        </iframe>
    </div>

    <div class="videochat-bar fo-card">
        <p class="videochat-state">Videochiamata in corso</p>
        <button type="button" class="fo-btn videochat-end" (click)="exit()">
            <mat-icon class="videochat-end__icon">call_end</mat-icon>
            <span>Termina</span>
        </button>
    </div>
</div>
